// frontend/src/features/equipment/EquipmentSetupWizard/steps/CirculationStep.tsx
import { CategoryStep } from './CategoryStep';
import type { PendingEquipment } from '../types';

interface CirculationStepProps {
  pendingEquipment: PendingEquipment[];
  onEquipmentChange: (equipment: PendingEquipment[]) => void;
  onManageInEquipment?: () => void;
  isCategoryComplete?: boolean;
}

export function CirculationStep({
  pendingEquipment,
  onEquipmentChange,
  onManageInEquipment,
  isCategoryComplete,
}: CirculationStepProps) {
  return (
    <CategoryStep
      categoryId="circulation"
      title="What's moving water in your tank?"
      pendingEquipment={pendingEquipment}
      onEquipmentChange={onEquipmentChange}
      onManageInEquipment={onManageInEquipment}
      isCategoryComplete={isCategoryComplete}
    />
  );
}
